import {LayoutCircleConfig, LayoutCircleType} from '../Layout/LayoutSection/Circles/LayoutSectionCircles.types';

const hubHeroCircles: LayoutCircleConfig = {
  desktop: [
    {
      type: LayoutCircleType.BLUE,
      style: {
        width: '54.4rem',
        top: '12.9rem',
        left: '-20rem',
      },
    },
    {
      type: LayoutCircleType.YELLOW,
      style: {
        width: '37.7rem',
        top: '-18.2rem',
        right: '-10rem',
      },
    },
    {
      type: LayoutCircleType.BLUE_BRIGHT,
      style: {
        width: '10.8rem',
        top: '23rem',
        right: '9rem',
      },
    },
    {
      type: LayoutCircleType.YELLOW_BRIGHT,
      style: {
        width: '4.7rem',
        top: '15rem',
        right: '25rem',
      },
    },
    {
      type: LayoutCircleType.BLUE_BRIGHT,
      style: {
        width: '6.8rem',
        top: '7rem',
        left: '24rem',
      },
    },
  ],
  tablet: [
    {
      type: LayoutCircleType.BLUE,
      style: {
        width: '54.4rem',
        top: '12.9rem',
        left: '-20rem',
      },
    },
    {
      type: LayoutCircleType.YELLOW,
      style: {
        width: '37.7rem',
        top: '-18.2rem',
        right: '-10rem',
      },
    },
  ],
};

export default hubHeroCircles;
